import { useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import AlertDialog from '@/components/base/MessageBanner/AlertDialog';
import type { AlertMessage } from '@/types/pbskids-graph';
import LanguageLocalizer from '@/utils/language-localization';
import styles from './MessageBanner.module.scss';

export default function MessageBanner(
  { messageData, onBannerLoaded }:
  { messageData: AlertMessage, onBannerLoaded?: () => void },
) {
  const { __t } = new LanguageLocalizer( useContext, 'components/base/MessageBanner' );
  const [ isActive, setIsActive ] = useState(false);

  const getCookieKey = (alertId: string) => `pbskids.${alertId}.banner-dismissed`;

  const closeAlert = (): void => {
    if (messageData) {
      const cookieKey = getCookieKey(messageData.id);
      Cookies.set(cookieKey, 'true', { expires: 1 });
      setIsActive(false);
    }
  };

  useEffect(() => {
    if (messageData?.alertMessage) {
      const cookieKey = getCookieKey(messageData.id);
      const previouslyDismissed = Cookies.get(cookieKey) === 'true';
      if (!previouslyDismissed) {
        setIsActive(true);
        onBannerLoaded?.();
      }
    }
  }, [ onBannerLoaded, messageData ]);

  return isActive &&
    <div
      data-component-message-banner
      className={styles.banner}>
      <AlertDialog
        bgColor={ messageData.alertMessageBackgroundColor || '' }
        label={ __t('dialogAriaLabel') }
        link={ messageData.alertMessageLinkUrl || '' }
        message={ messageData.alertMessage || '' }
        onClose={closeAlert}
        textColor={ messageData.alertMessageTextColor || '' }
      />
    </div>;
}
